export function dateKey(date) {
  return `${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}-${date.getFullYear()}`;
}
export const slotKey = (trainer, date, time) => `${trainer}|${date}|${time}`;
export const isBusySlot = (requests, trainer, date, time) => requests.some(request => request.trainer === trainer && request.date === date && request.time === time && request.status !== 'failed');
export function mergeBookingDraft(serverData, localData, dirtySlots, requests) {
  const merged = Object.fromEntries(Object.entries(serverData || {}).map(([trainer, dates]) => [trainer, Object.fromEntries(Object.entries(dates || {}).map(([date, times]) => [date, Array.isArray(times) ? [...times] : []]))]));
  for (const key of Object.keys(dirtySlots)) {
    const [trainer, date, time] = key.split('|');
    if (isBusySlot(requests, trainer, date, time)) { delete dirtySlots[key]; continue; }
    const selected = localData[trainer]?.[date]?.includes(time);
    merged[trainer] ||= {};
    merged[trainer][date] ||= [];
    merged[trainer][date] = merged[trainer][date].filter(item => item !== time);
    if (selected) merged[trainer][date].push(time);
  }
  return merged;
}

export function dirtySlotChanges(dirtySlots, selectedTimes) {
  return Object.keys(dirtySlots).map(key => {
    const [trainer, date, time] = key.split('|');
    return { trainer, date, time, selected: !!selectedTimes[trainer]?.[date]?.includes(time) };
  });
}
